import styled from "styled-components"
import {  Link  } from 'react-router-dom';


export default function Nav() {
    return (
        <StyledContainer>
            <header className="flex flex-col items-start space-y-4 right-container">
                <nav className="flex space-x-4 justify-end w-full">
                    <Link to="/" className="px-3 py-1 link-box"> Home </Link>
                    <Link to="/atlas" className="px-3 py-1 link-box"> Atlas </Link>
                    <Link to="/coexp" className="px-3 py-1 link-box"> Co Exp.</Link>
                    <a href="https://www.csbiology.org/" target="_blank" rel="noreferrer" className="px-3 py-1 link-box">CSBL</a>
                </nav>
            </header>
        </StyledContainer>
    )
}


const StyledContainer = styled.div`

    .right-container {
        display: flex; 
        justify-content: right; 
        align-items: right; 
    }
    .link-box {
        border: 1px solid #000;
        padding: 6px 12px;
        border-radius: 4px;
        text-decoration: none;
        color: #000;
        font-weight: 600;
    }


    .content-box {
        border: 2px solid #000;
        padding: 16px;
        border-radius: 6px;
    }

`